/**************
 Global
 ***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**************
 Design mode open mini cart
 ***************/
if (Shopify.designMode) {
    // if a user clicks on the mini cart
    document.addEventListener('shopify:section:select', function (event) {
        // open mini cart
        if (event.detail.sectionId === 'theme-mini-cart') {
            openCart();
        }

        // if they deselect the mini cart
        if (event.detail.sectionId !== 'theme-mini-cart') {
            closeCart();
        }
    });
}

// scroll to url hash
const maltertechParams = new URLSearchParams(window.location.search);

if (maltertechParams.get("scroll_to_class")) {
    const element = document.querySelector(`.${maltertechParams.get("scroll_to_class")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

if (maltertechParams.get("scroll_to_id")) {
    const element = document.querySelector(`#${maltertechParams.get("scroll_to_id")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

// scroll to product if button with 'scrollProduct' href is clicked
document.querySelectorAll(`[href="#scrollProduct"]`).forEach(element => element.addEventListener("click", function (e) {
    e.preventDefault();

    // if on product page or if there is a product section on the page
    if ((window.location.pathname.includes('/products/dog-hydration') || document.querySelector('[id*="main_product"]'))) {

        // close slider if open
        if (document.querySelector('#slider')?.open) {
            closeNav();
        }

        // close miniCart if open
        if (document.querySelector('#miniCart')?.open) {
            closeCart();
        }


        window.scrollTo({
            top: document.querySelector('[id*="main_product"]')?.offsetTop - 120,
            behavior: "smooth"
        });
    } else {
        // store the element needed to scroll to
        localStorage.setItem('scrollEl', 'main_product');
        // navigate to the product page
        window.location.href = "/products/dog-hydration";
    }
}));

// scroll to nearest faq section if button with 'scrollFaq' href is clicked
document.querySelectorAll(`[href="#scrollFaq"]`).forEach(element => element.addEventListener("click", function (e) {
    e.preventDefault();
    // if on product page or if there is a faq section on the page
    if (window.location.pathname.includes('/products/dog-hydration') || document.querySelector('[id*="section_faq"]')) {
        // close slider
        closeNav();

        // scroll down to reviews
        window.scrollTo({
            top: document.querySelector('[id*="section_faq"]') ? document.querySelector('[id*="section_faq"]').offsetTop - 120 : "",
            behavior: "smooth"
        });
    } else {
        // store the element needed to scroll to
        localStorage.setItem('scrollEl', 'section_faq');
        // navigate to the product page
        window.location.href = "/products/dog-hydration";
    }
}));

// scroll to nearest reviews section if button with 'scrollReviews' href is clicked
document.querySelectorAll(`[href="#scrollReviews"]`).forEach(element => element.addEventListener("click", function (e) {
    e.preventDefault();
    // if on product page or if there is a review section on the page
    if (window.location.pathname.includes('/products/dog-hydration') || document.querySelector('[id*="section_testimonials_carousel"]')) {
        // close slider
        closeNav();

        // scroll down to reviews
        window.scrollTo({
            top: document.querySelector('[id*="section_testimonials_carousel"]') ? document.querySelector('[id*="section_testimonials_carousel"]').offsetTop - 120 : "",
            behavior: "smooth"
        });
    } else {
        // store the element needed to scroll to
        localStorage.setItem('scrollEl', 'section_testimonials_carousel');
        // navigate to the product page
        window.location.href = "/products/dog-hydration";
    }
}));

// on load, scroll to section if local storage item exists

if (localStorage.getItem('scrollEl')) {
    window.onload = scrollToSection;
}

// scroll to needed section
function scrollToSection() {
    let scrollElement = localStorage.getItem('scrollEl');
    window.scrollTo({
        top: document.querySelector(`[id*="${scrollElement}"]`) ? document.querySelector(`[id*="${scrollElement}"]`).offsetTop - 120 : "",
        behavior: "smooth"
    });

    // clear local storage
    localStorage.removeItem('scrollEl');
}

// toggle open quiz popup
document.querySelectorAll('.openQuiz').forEach(element => element.addEventListener("click", function (e) {
    e.preventDefault();
    document.querySelector('#quizPopup').showModal();
    // add no scroll
    document.body.classList.add('noScroll')
}));


// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID) {
    await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${await klaviyo.account()}`, {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantID}`,
                        }
                    }
                }
            }
        })
    })
}